import * as React from 'react'
import { createStore } from 'zustand'
import { useStoreWithEqualityFn } from 'zustand/traditional'

type VariantSetStore = {
  focusedVariantId: string | null
  setFocusedVariantId: (id: string | null) => void
}

export const createVariantSetStore = () => {
  return createStore<VariantSetStore>()((set) => ({
    focusedVariantId: null,
    setFocusedVariantId: (id) => set({ focusedVariantId: id }),
  }))
}

export const VariantStoreContext = React.createContext<ReturnType<
  typeof createVariantSetStore
> | null>(null)

export function useVariantSetStore<T>(
  selector: (state: VariantSetStore) => T,
  compare?: (prev: T, next: T) => boolean
): T {
  const store = React.useContext(VariantStoreContext)
  if (!store) {
    throw new Error('Missing VariantStoreContext.Provider in the tree')
  }
  return useStoreWithEqualityFn(store, selector, compare)
}

export const VariantStoreProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const store = React.useMemo(() => createVariantSetStore(), [])
  return (
    <VariantStoreContext.Provider value={store}>
      {children}
    </VariantStoreContext.Provider>
  )
}
